/**
 * Utility functions for rendering sorting indicators in table column headers
 */

/**
 * Get the sort indicator symbol based on sort order
 * @param sortOrder - 'ascend', 'descend', null, or undefined
 * @returns string with the appropriate indicator
 */
export const getSortIndicator = (
  sortOrder: "ascend" | "descend" | null | undefined
): string => {
  if (sortOrder === "ascend") {
    return " ↑";
  } else if (sortOrder === "descend") {
    return " ↓";
  }
  return "";
};

/**
 * Get the sort text label based on sort order
 * @param sortOrder - 'ascend', 'descend', null, or undefined
 * @returns string with the sort direction label
 */
export const getSortLabel = (
  sortOrder: "ascend" | "descend" | null | undefined
): string => {
  if (sortOrder === "ascend") {
    return " (ASC)";
  } else if (sortOrder === "descend") {
    return " (DESC)";
  }
  return "";
};

/**
 * Create a title with sort indicator for table columns
 * @param baseTitle - The original column title
 * @param sortOrder - Current sort order
 * @param useSymbol - If true, use arrow symbols; if false, use text labels
 * @returns JSX element or string with sorting indicator
 */
export const getSortTitle = (
  baseTitle: string,
  sortOrder: "ascend" | "descend" | null | undefined,
  useSymbol: boolean = true
): string => {
  const indicator = useSymbol
    ? getSortIndicator(sortOrder)
    : getSortLabel(sortOrder);
  return baseTitle + indicator;
};
